import { Component, Inject } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DynamicFormQuestionComponent } from '../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { CommonModule } from '@angular/common';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { Inputfiledsbase } from '../../../inputfileds/models/inputfiledsbase';
import { CoursesService } from '../../../inputfileds/form_services/courses/courses.service';
import { Observable, forkJoin } from 'rxjs';
import { QuestionService } from '../../../inputfileds/form_services/question/question.service';
import { QuestionControlService } from '../../../inputfileds/form_services/question-control.service';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { AddsemestersComponent } from '../semesters/addsemesters/addsemesters.component';
import { ToastComponent } from '../../../components/toast/toast.component';
import { ToastService } from '../../../Services/toast/toast.service';
import { DropdownservicesService } from '../../../Services/Apis/Dropdownservices/dropdownservices.service';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';

export interface Coursemodel {
  // organization_id: number;
  course_type_id: number;
  course_name: string;
  course_type: string;
  stream_id: number;
  stream_name: string;
  course_code: string;
  start_date: number;
  // stream_type: string,
  // stream_type_id: number;
  duration_type_id: number;
  duration_type_name: string;
  duration: string;
  description: string;
  number_of_semisters: number;
  medium: []; 
}
export interface medium {
  medium_name:string;
  medium_type_id: number
}
@Component({
    selector: 'app-addcourses',
    imports: [
        // AddsemestersComponent,
        ReactiveFormsModule,
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatDividerModule,
        DynamicFormQuestionComponent,
        MatIconModule,
        ToastComponent,
        TranslateDirective
    ],
    templateUrl: './addcourses.component.html',
    styleUrl: './addcourses.component.scss',
    providers: [QuestionControlService, CoursesService, ApiservicesService, DropdownservicesService],
    standalone:true
})
export class AddcoursesComponent {
  questions: Inputfiledsbase<string>[] | null = [];
  questions$: Observable<Inputfiledsbase<any>[]> | null;
  courseform!:  FormGroup;
  datesend!: Coursemodel;
  semisterflag: boolean = false;
  coursedata: any = {};
  optionsdata:any = [];
  selected_option: any = [];
  errorMessage = '';
  constructor(
    private dialogRef: MatDialogRef<AddcoursesComponent>,
    private apiservice: ApiservicesService,
    private dropdownservice : DropdownservicesService,
    private services: CoursesService, 
    private router: Router,
    private qcs: QuestionControlService, 
    private toast : ToastService,
    @Inject(MAT_DIALOG_DATA) public data:any
  ){
    this.questions$ = services.getcoursesform();
    this.questions$.subscribe(q => {
      this.questions = q;
      this.optionsdata = q[3].options; 
      this.selected_option.push(this.optionsdata[0]) 
    });
  }
  
  ngOnInit(): void {
    this.courseform = this.qcs.toFormGroup(this.questions as Inputfiledsbase<string>[]);
    this.courseform.patchValue({medium: this.selected_option})
  }

  gotosemisters(){
    this.semisterflag = !this.semisterflag;
  }

  closeDialog(event:any){
    // this.dialogRef.close();
    this.gotosemisters()
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeIn")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOut");
    setTimeout(()=>{this.dialogRef.close(event);}, 1000);
  }

  
  onSubmit() {
    let medium_data: any = [];
    this.courseform.value.medium.map((a:any)=>{
      medium_data.push({medium_name: a.name, medium_type_id: a.id});  
    })


    this.datesend = {
      medium: medium_data,
      // organization_id: parseInt(this.courseform.value.organization_id),
      course_type_id: parseInt(this.courseform.value.course_type_id),
      course_name: this.courseform.value.course_name,
      course_type: this.courseform.value.course_type,
      course_code: this.courseform.value.course_code,
      stream_id: parseInt(this.courseform.value.stream_id),
      stream_name: this.courseform.value.stream_name,
      start_date: parseInt(this.courseform.value.start_date),
      // stream_type: string,
      // stream_type_id: number;
      duration_type_id: parseInt(this.courseform.value.duration_type_id),
      duration_type_name: this.courseform.value.duration_type,
      duration: this.courseform.value.duration,
      description: this.courseform.value.description,
      number_of_semisters: parseInt(this.courseform.value.number_of_semisters)  
    }
    // this.datesend.number_of_semisters = parseInt(this.courseform.value.number_of_semisters);

    forkJoin([
      this.dropdownservice.getstreamdropdown(),
      this.dropdownservice.getlookupcodesdropdown('COURSE_TYPES'),
      this.dropdownservice.getlookupcodesdropdown('DURATION_TYPES'),
      this.dropdownservice.getlookupcodesdropdown('STREAM_TYPES'),
    ]).subscribe(([StramRes, CourseRes, DurationRes, StramtypeRes]) => {
      const filteredStream = StramRes.find((dropfilter:any) => { return dropfilter.id === parseInt(this.courseform.value?.stream_id) });
      const filteredCourse = CourseRes.find((dropfilter: any) => { return dropfilter.id === parseInt(this.courseform.value?.course_type_id) });
      const filteredDuration = DurationRes.find((dropfilter: any) => { return dropfilter.id === parseInt(this.courseform.value?.duration_type_id)});
      // const filteredStramtype = StramtypeRes.find((dropfilter: any) => { return dropfilter.id === this.courseform.value?.gender_id });
      this.datesend.stream_name = filteredStream?.name
      this.datesend.course_type = filteredCourse?.lookup_name 
      this.datesend.duration_type_name = filteredDuration?.lookup_name
      this.datesend.start_date = this.courseform.value?.start_date
      // this.datesend = { ...this.datesend, stream_type: filteredStramtype?.lookup_name };
      this.createAPi(this.datesend)
    });
  }

  createAPi(event:any){
    this.apiservice.createcourses(event).subscribe((res: any) => {
      if(res.code === 201 && res.status === true){
        if(this.data.total_count == 0 ){
          this.apiservice.onboarding_status_updation({"module_name":"COLLEGE_MANAGEMENT_SYSTEM","sub_module_name":"COURSES"}).subscribe();
        }
        this.toast.showToast('success', 'Saved Successfuly');
        this.coursedata = res.data;
        // this.courseform.reset();
        this.closeDialog(true);
        // window.location.href = this.router.url;
        // this.closeDialog(true);
      }
      else{
          this.errorMessage = res.message;
          this.toast.showToast('danger', `Error: ${res.message}`);
      }
      })
  }
}
